import { useEffect, useState } from "react";
import axios from 'axios';

const Vestibular = () => {
  const [turmas, setTurmas] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [nomeTurma, setNomeTurma] = useState("");

  useEffect(() => {
    const fetchTurmas = async () => {
      setLoading(true);
      try {
        const response = await axios.get("http://localhost:5000/turmas", {
          params: { NomeTurma: nomeTurma }
        });
        setTurmas(response.data); // Acessa os dados corretamente
      } catch (error) {
        console.error("Erro ao carregar turmas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTurmas();
  }, [nomeTurma]); // Atualiza a lista ao alterar o nome da turma

  if (loading) return <p>Carregando turmas...</p>;

  return (
    <div>
      <h1>Turmas Disponíveis - Vestibular</h1>

      <input
        type="text"
        placeholder="Buscar por nome da turma"
        value={nomeTurma}
        onChange={(e) => setNomeTurma(e.target.value)}
      />

      {turmas.length === 0 ? (
        <p>Nenhuma turma disponível</p>
      ) : (
        <ul>
          {turmas.map((turma: any) => (
            <li key={turma.id}>
              <h3>{turma.nomeTurma}</h3>
              <p>Localidade: {turma.localidade}</p>
              <p>Carga Horária: {turma.cargaHoraria}h</p>
              <p>Preço: R$ {turma.preco}</p>
              <a href={turma.linkMatriculaOnline} target="_blank" rel="noopener noreferrer">
                Fazer Matrícula
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Vestibular;
